export function displayEnumValue(value = "") {
  const valueLower = value.replace(/_/g, " ").toLowerCase();

  return valueLower.charAt(0).toUpperCase() + valueLower.slice(1);
}
